/**
 * 解析所有组件的value值，转换成组件可使用的类型
 */
import { log } from '.';
import { IValue } from '../model';

export const getDynamicSelectedValue = (value: any, isMultiple: boolean) => {
  let selectedValue: any = '';

  try {
    selectedValue = typeof value === 'string' ? JSON.parse(value) : value;
  } catch (err) {
    log.error(err);
  }

  if (isMultiple) {
    return selectedValue.value || [];
  }
  return selectedValue.value || '';
};

export const getDynamicRadioValue = (value: IValue) => {
  if (typeof value !== 'object') {
    log.error('Radio default value type require [IValue]');
    return '';
  }

  if (typeof value.value === 'string' || typeof value.value === 'number') {
    return `${value.value}`;
  }
  return '';
};

export const getDynamicSwitchValue = (value: IValue) => {
  if (typeof value !== 'object') {
    log.error('Switch default value type require [IValue]');
    return false;
  }

  if (typeof value.value === 'string' || typeof value.value === 'number') {
    return !!value.value;
  }
  return false;
};

export const getDynamicCheckboxValue = (value: IValue) => {
  if (typeof value !== 'object') {
    log.error('Checkbox default value type require [IValue]');
    return [];
  }

  if (Array.isArray(value.value)) {
    return value.value;
  }
  return [];
};
